var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-button",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"back-icon"},[_vm._v("←")]),_c('span',{staticClass:"back-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }